module.exports = __webpack_public_path__ + "icon-goto@2x.png?1a2a3f28e504b41dc74ed3ff8cffc9a1";